import { trackEvent } from "services/bigbrain-service";
import { getDefaultTierDescriptions } from "constants/pricing/pricing-page/tier-descriptions";
import { PRICING_PAGE_CLUSTERIZED_INFO_PRESENTED } from "constants/bigbrain-event-types";
import { getTierDescriptionsFromClusterConfig, isInClusterTest } from "./clusterized-pricing-page-service";
export const getTierDescriptions = (clusterId, clusterConfig, { abTests, cookies, forcePricing, hasStudentPlan })=>{
    var _clusterConfig_payments_view;
    const pricingPageConfig = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : _clusterConfig_payments_view.pricing;
    if (!(pricingPageConfig === null || pricingPageConfig === void 0 ? void 0 : pricingPageConfig.tier_descriptions) || !isInClusterTest(clusterConfig, {
        abTests,
        cookies,
        forcePricing
    })) {
        return getDefaultTierDescriptions({
            hasStudentPlan
        });
    }
    const clusterizedTierDescriptions = getTierDescriptionsFromClusterConfig(pricingPageConfig, clusterId, {
        abTests,
        cookies,
        forcePricing,
        hasStudentPlan
    });
    trackEvent(PRICING_PAGE_CLUSTERIZED_INFO_PRESENTED, {
        kind: "user_experience_for_cluster",
        info1: clusterId,
        info2: "payments_view[pricing]",
        data: pricingPageConfig.tier_descriptions,
        placement: "tier_descriptions"
    });
    return clusterizedTierDescriptions;
};
